import React from 'react'
import Bookings from '../components/Bookings'
import Header from '../components/Header'

const Layout = () => {
  return (
    <>
        <Header/>
        <Bookings/>
    </>
  )
}

export default Layout